// clinicOptions.jsx — the TEST chip, in one place.
//
// Thérapie Maps publishes test clinics in a separate lane and the API merges them
// back in for SuperAdmins only (getReferenceClinics). They look exactly like any
// other clinic apart from `visibility: 'internal'`, which is the point: nothing
// in the UI may hardcode a clinic name to spot one.
//
// A test clinic that is not obviously a test clinic is how a real adverse event
// ends up filed somewhere it will never be actioned — so the chip shows in the
// dropdown list AND on the closed picker once chosen (SearchableSelect renders an
// option's `meta` in both).

/** True for a clinic row that Maps marks as internal/test. */
export function isTestClinic(c) {
  return String(c?.visibility || '').toLowerCase() === 'internal';
}

/** The `meta` node for a clinic option — a TEST chip, or nothing. */
export function clinicMeta(c) {
  return isTestClinic(c) ? <span className="clinic-test-chip">Test</span> : undefined;
}
